import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from "@angular/common/http";

import { Observable } from "rxjs";
import { LoaderService } from "../services/loader.service";
import { finalize } from "rxjs/operators";

export const SKIP_LOADER_INTERCEPTOR = new HttpContextToken(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const skipLoaderInterceptor = req.context
      .get(SKIP_LOADER_INTERCEPTOR)
      .valueOf();

    if (skipLoaderInterceptor) {
      return next.handle(req);
    }

    if (this.activeRequests === 0) {
      this.loaderService.show();
    }

    this.activeRequests++;

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;

        if (this.activeRequests === 0) {
          this.loaderService.hide();
        }
      })
    );
  }
}
